const PageNotFound = () => {
    return (
    <h1 style ={{textAlign:'center'}}>Page not found</h1>     

    )
}

export default PageNotFound